import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { CheckCircle2, Phone, ArrowRight } from "lucide-react";
import { COMPANY } from "../mock";

export default function ServiceDetailModal({ open, onOpenChange, service, onBook }) {
  if (!service) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto p-0 gap-0">
        <div className="relative h-56 overflow-hidden rounded-t-lg">
          <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#07304f] via-[#07304f]/40 to-transparent" />
          <div className="absolute bottom-4 left-6 right-6">
            <DialogHeader>
              <DialogTitle className="text-3xl font-extrabold text-white drop-shadow">
                {service.title}
              </DialogTitle>
              <DialogDescription className="text-white/85 mt-1">
                {service.short}
              </DialogDescription>
            </DialogHeader>
          </div>
        </div>

        <div className="p-6">
          <p className="text-slate-700 leading-relaxed mb-6">{service.description}</p>

          {service.features && service.features.length > 0 && (
            <div className="mb-6">
              <h4 className="font-bold text-[#0a4f8a] mb-3 text-sm uppercase tracking-wider">
                What's included
              </h4>
              <ul className="grid sm:grid-cols-2 gap-2">
                {service.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-slate-700 text-sm">
                    <CheckCircle2 size={18} className="text-sky-600 shrink-0 mt-0.5" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="bg-sky-50 border border-sky-100 rounded-lg p-4 mb-6 text-sm text-slate-700">
            <strong className="text-[#0a4f8a]">Servicing all of Sydney</strong> — same-day
            appointments available. Honest upfront pricing with no hidden fees.
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={() => {
                onOpenChange(false);
                onBook(service);
              }}
              className="flex-1 bg-sky-600 hover:bg-sky-700 text-white font-bold py-6 group"
            >
              Book this service
              <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
            </Button>
            <a href={`tel:${COMPANY.phoneLink}`} className="flex-1">
              <Button
                variant="outline"
                className="w-full border-[#0a4f8a] text-[#0a4f8a] hover:bg-[#0a4f8a] hover:text-white font-semibold py-6"
              >
                <Phone size={16} className="mr-2" /> {COMPANY.phone}
              </Button>
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
